import { useAtom } from 'jotai'

import { userAtom } from '@/global-state'
import { usePathname } from '@/i18n-routing'

import { isAnyOfPurchaseLayoutRoutes } from '../../../utils/routes'
import { isPremiumOrPremiumCancelling } from '../../auth/utils/userStates'

export type TErrorPageHandledCode = '403' | '404' | '500'

export const useErrorCode = (): TErrorPageHandledCode => {
	const pathname = usePathname()
	const [user] = useAtom(userAtom)

	const determineErrorCode = (pathname: string) => {
		if (
			user &&
			isPremiumOrPremiumCancelling(user) &&
			isAnyOfPurchaseLayoutRoutes(pathname)
		) {
			return '403'
		}

		return '404'
	}

	return determineErrorCode(pathname)
}
